import React from 'react'
import t from 'prop-types'
import IconArrow from '../../Icons/IconArrow'
import { Link } from 'gatsby'

const LinkWithIcon = ({ image, link }) => {
  return (
    <Link
      className="group flex items-center tracking-wide uppercase"
      to={link.url}
      target={link.target || null}
    >
      <span className="text-lg md:text-xl leading-none font-medium transition-colors ease-linear duration-200 text-blue-200 group-hover:text-blue-100">
        {link.label}
      </span>
      <div className="ml-3 w-8 md:w-10">
        <IconArrow width="100%" height="100%"></IconArrow>
      </div>
    </Link>
  )
}

LinkWithIcon.propTypes = {
  image: t.object,
  link: t.object,
}

LinkWithIcon.defaultProps = {}

export default LinkWithIcon
